export enum ENote {
  BeforeMeal = 'before-meal',
  AfterMeal = 'after-meal',
  DuringMeal = 'during-meal',
  WhenSick = 'when-sick',
  BeforeSleep = 'before-sleep'
}
